import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable max-depth */
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
import { connect } from "react-redux";
import { closeCustomerCaptureOverlay as _closeCustomerCaptureOverlay } from "web/redux/ducks/customer-capture-overlay";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import requester from "web/script/modules/requester";
import userProfiler from "web/script/modules/userprofiler";
import url from "web/script/utils/url";
import CloseButton from "web/react/components/buttons/close-button/close-button";
import withReduxProvider from "web/react/redux-provider";
import EmailCaptureForm from "web/react/components/email-capture-form/email-capture-form";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import styles from "./email-capture-overlay.css";
var CAPTURE_TYPE_SIGNUP_LEAD_SAVE = "signup_lead_save";
var CAPTURE_TYPE_SIGNUP_OOS_SAVE = "signup_oos_save";
var CAPTURE_TYPE_SIGNUP_PDP_SAVE = "signup_pdp_save";
var CAPTURE_TYPE_SIGNUP_FEED_SAVE = "signup_feed_save";
var CAPTURE_TYPE_SIGNUP_DU = "signup_du";
var CAPTURE_TYPE_SIGNUP_SEARCH = "signup_search";
var CAPTURE_TYPE_STOCK_ALERT = "stock_alert";
var CAPTURE_TYPE_STOCK_ALERT_LEAD_RETURN = "stock_alert_lead_return";
var CAPTURE_TYPE_TA_COLLECTION = "ta_collection";

function createMarkup(value) {
  return {
    __html: value
  };
}

function mapStateToProps(state) {
  var _state$customerCaptur = state.customerCaptureOverlayReducer,
      captureType = _state$customerCaptur.captureType,
      designerId = _state$customerCaptur.designerId,
      next = _state$customerCaptur.next,
      open = _state$customerCaptur.open,
      productId = _state$customerCaptur.productId,
      searchGender = _state$customerCaptur.searchGender,
      searchTerm = _state$customerCaptur.searchTerm;
  return {
    captureType: captureType,
    designerId: designerId,
    next: next,
    overlayOpen: open,
    productId: productId,
    searchGender: searchGender,
    searchTerm: searchTerm
  };
}

function mapDispatchToProps(dispatch) {
  return {
    closeCustomerCaptureOverlay: function closeCustomerCaptureOverlay() {
      return dispatch(_closeCustomerCaptureOverlay());
    }
  };
}

export function EmailCaptureOverlay(_ref) {
  var captureType = _ref.captureType,
      closeCustomerCaptureOverlay = _ref.closeCustomerCaptureOverlay,
      cookiePolicyLink = _ref.cookiePolicyLink,
      designerId = _ref.designerId,
      next = _ref.next,
      overlayOpen = _ref.overlayOpen,
      privacyPolicyLink = _ref.privacyPolicyLink,
      productId = _ref.productId,
      searchGender = _ref.searchGender,
      searchTerm = _ref.searchTerm,
      termsAndConditionsLink = _ref.termsAndConditionsLink,
      shortPolicy = _ref.shortPolicy,
      signInLink = _ref.signInLink;
  var appElement;

  if (document.body) {
    appElement = document.body.querySelector(".site-wrapper") || undefined;
  }

  useEffect(function () {
    disableBodyScroll(appElement);
    return function () {
      clearAllBodyScrollLocks();
    };
  }, [appElement]);
  var emailLabelText = gettext("account.form.email_label");
  var submitText;
  var title;
  var type;

  switch (captureType) {
    case CAPTURE_TYPE_SIGNUP_PDP_SAVE:
    case CAPTURE_TYPE_SIGNUP_FEED_SAVE:
      submitText = gettext("account.register.return_lead_btn_txt_track_deals");
      title = gettext("saved_items.sign_up_save_item_title_option_b");
      type = "save_for_later";
      break;

    case CAPTURE_TYPE_SIGNUP_LEAD_SAVE:
      submitText = gettext("account.register.return_lead_btn_txt_get_deals");
      title = gettext("account.register.return_lead_title");
      type = "save_for_later_lead_return";
      break;

    case CAPTURE_TYPE_SIGNUP_SEARCH:
      submitText = gettext("account.register.return_lead_btn_follow_search");
      title = gettext("account.register.return_lead_title_follow_search", {
        search_terms: searchTerm
      });
      type = "saved_search";
      break;

    case CAPTURE_TYPE_SIGNUP_OOS_SAVE:
    case CAPTURE_TYPE_STOCK_ALERT:
      submitText = gettext("general.alert_me");
      title = gettext("email_capture.stock_alert.title");
      type = "back_in_stock";
      break;

    case CAPTURE_TYPE_STOCK_ALERT_LEAD_RETURN:
      submitText = gettext("general.alert_me");
      title = gettext("email_capture.stock_alert.title_when_triggered_by_lead_link");
      type = "back_in_stock";
      break;

    case CAPTURE_TYPE_SIGNUP_DU:
      submitText = gettext("account.register.return_lead_btn_follow_products_designer");
      title = gettext("account.register.return_lead_title_follow_products_designer");
      type = "designer_update_lyst";
      break;

    case CAPTURE_TYPE_TA_COLLECTION:
      submitText = gettext("account.register.sign_up_button");
      title = gettext("homepage.sign_up.header_shop_thousands_favourite_stores");
      type = "ta_collection";
      break;
  } // Hooks


  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      emailAddress = _useState2[0],
      setEmailAddress = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      privacyPolicy = _useState4[0],
      setPrivacyPolicy = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      marketingEmails = _useState6[0],
      setMarketingEmails = _useState6[1];

  var _useState7 = useState(undefined),
      _useState8 = _slicedToArray(_useState7, 2),
      formErrors = _useState8[0],
      setFormErrors = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      successMessage = _useState10[0],
      setSuccessMessage = _useState10[1];

  var hidden;
  var visibilityChange;

  if (typeof document.hidden !== "undefined") {
    hidden = "hidden";
    visibilityChange = "visibilitychange";
  } else if (typeof document.msHidden !== "undefined") {
    hidden = "msHidden";
    visibilityChange = "msvisibilitychange";
  } else if (typeof document.webkitHidden !== "undefined") {
    hidden = "webkitHidden";
    visibilityChange = "webkitvisibilitychange";
  }

  function handleVisibilityChange() {
    if (!document[hidden]) {
      analytics.event(captureType, "view_form", "back_overlay");
      document.removeEventListener(visibilityChange, handleVisibilityChange);
    }
  }

  useEffect(function () {
    return function () {
      document.removeEventListener(visibilityChange, handleVisibilityChange);
    };
  });

  function triggerAfterOpen() {
    analytics.event(captureType, "open_signup_form", "open_overlay", true); // non interactive

    document.addEventListener(visibilityChange, handleVisibilityChange, false);
  }

  function triggerClose() {
    if (captureType === "ta_collection") {
      return false;
    }

    analytics.event(captureType, "close_signup_form", "exit_signup");
    document.removeEventListener(visibilityChange, handleVisibilityChange);
    closeCustomerCaptureOverlay();
  }

  function changeEmail(event) {
    setEmailAddress(event.target.value);
  }

  function handleLegalChange(privacyPolicyChecked, marketingEmailsChecked) {
    setPrivacyPolicy(privacyPolicyChecked);
    setMarketingEmails(marketingEmailsChecked);
  }

  function onSubmit(_x) {
    return _onSubmit.apply(this, arguments);
  }

  function _onSubmit() {
    _onSubmit = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(event) {
      var seenProducts, productIds, body, parsedURL, path, params, nextParam, searchTermParam, searchGenderParam, jsonData, queryParams, errors;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();
              analytics.event(captureType, "click_signup_button", "signup_button");
              seenProducts = userProfiler.getSeenProducts();
              productIds = [];

              if (seenProducts) {
                productIds = seenProducts.reduce(function (memo, product) {
                  memo.push(product.productId);
                  return memo;
                }, []);
              }

              body = {
                designer_id: designerId,
                email: emailAddress,
                invisible_pids: productIds.join(","),
                marketing_emails: marketingEmails,
                privacy_policy: privacyPolicy
              };
              parsedURL = url.parse(window.location); // work out what the 'next' parameter should be

              if (captureType !== "ta_collection") {
                parsedURL.searchParams.set("loggedin", "true");
                parsedURL.searchParams.set("area", "heart");
              }

              path = next || parsedURL.path;
              params = url.toQueryString(parsedURL.searchParams);
              nextParam = next || "".concat(path).concat(params && "?".concat(params));
              searchTermParam = searchTerm || parsedURL.searchParams.get("q");
              searchGenderParam = searchGender || parsedURL.searchParams.get("gender") || parsedURL.searchParams.get("meta_gender");
              jsonData = undefined;
              queryParams = url.toQueryString({
                type: type,
                product_id: productId,
                designer_id: designerId,
                search_query: searchTermParam,
                search_gender: searchGenderParam,
                email_capture: "true",
                next: nextParam
              }).toString();
              _context.prev = 15;
              _context.next = 18;
              return requester.post("/account/register/?".concat(queryParams), body);

            case 18:
              jsonData = _context.sent;
              _context.next = 27;
              break;

            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](15);
              console.error(_context.t0);
              setFormErrors({
                other: [gettext("account.login.with_magic_link.error_title")]
              });
              analytics.event(captureType, "error_signup", "server_error");
              return _context.abrupt("return");

            case 27:
              if (jsonData && jsonData.success) {
                if (captureType !== "ta_collection") {
                  closeCustomerCaptureOverlay();
                  window.location = jsonData.data ? jsonData.data.next : nextParam;
                } else {
                  setSuccessMessage(true);
                }
              } else {
                errors = jsonData.data.errors;
                Object.keys(errors).map(function (key) {
                  if (key === "marketing_emails") {
                    analytics.event(captureType, "missed_tickbox", "tickbox");
                  }
                });
                setFormErrors(errors);
              }

            case 28:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[15, 21]]);
    }));
    return _onSubmit.apply(this, arguments);
  }

  function onSocialClick(authProvider) {
    event.preventDefault(); // signup_facebook, signup_google

    analytics.event(captureType, "click_social_sign_up", "signup_".concat(authProvider));

    if (privacyPolicy !== true || marketingEmails !== true) {
      setFormErrors({
        privacy_policy: [gettext("account.register.user_must_tick_both_boxes")]
      });
      return;
    } // start with the current URL (including all query parameters)


    var parsedURL = url.parse(window.location); // work out what the 'next' parameter should be

    var nextParam = next || url.unparse(parsedURL); // update the path to point to the correct auth provider

    parsedURL.path = "/social/login/".concat(authProvider, "/");
    parsedURL.searchParams.set("next", nextParam);
    parsedURL.searchParams.set("isLogin", false);
    parsedURL.searchParams.set("marketingEmails", marketingEmails);
    parsedURL.searchParams.set("productId", productId);
    parsedURL.searchParams.set("designerId", designerId);
    parsedURL.searchParams.set("authType", type);
    parsedURL.searchParams.set("searchQuery", searchTerm);
    parsedURL.searchParams.set("searchGender", searchGender); // do the redirect

    window.location = url.unparse(parsedURL);
  }

  function getSignInLinkProps() {
    if (captureType === "ta_collection") {
      return null;
    }

    var parsedURL = url.parse(window.location); // work out what the 'next' parameter should be

    parsedURL.searchParams.set("loggedin", "true");
    parsedURL.searchParams.set("area", "heart");
    var path = next || parsedURL.path;
    var params = url.toQueryString(parsedURL.searchParams);
    var nextParam = next || "".concat(path).concat(params && "?".concat(params));
    var searchTermParam = searchTerm || parsedURL.searchParams.get("q");
    var searchGenderParam = searchGender || parsedURL.searchParams.get("gender") || parsedURL.searchParams.get("meta_gender");
    var queryParams = url.toQueryString({
      type: type,
      product_id: productId,
      designer_id: designerId,
      search_query: searchTermParam,
      search_gender: searchGenderParam,
      email_capture: "true",
      next: nextParam
    }).toString();
    return signInLink + "?" + queryParams;
  }

  if (!overlayOpen) {
    return null;
  }

  return React.createElement("div", {
    id: "customer-capture-overlay"
  }, React.createElement(Modal, {
    appElement: appElement,
    isOpen: overlayOpen,
    onAfterOpen: triggerAfterOpen,
    onRequestClose: triggerClose,
    className: styles.modal,
    overlayClassName: styles.overlay
  }, !successMessage && React.createElement(React.Fragment, null, captureType !== "ta_collection" && React.createElement(CloseButton, {
    className: styles.closeButton,
    onClick: triggerClose
  }), React.createElement("div", {
    className: styles.captureForm
  }, React.createElement("h3", {
    className: styles.header,
    dangerouslySetInnerHTML: createMarkup(title)
  }), React.createElement(EmailCaptureForm, {
    captureType: captureType,
    cookiePolicyLink: cookiePolicyLink,
    emailAddress: emailAddress,
    emailLabelText: emailLabelText,
    formErrors: formErrors,
    onEmailChange: changeEmail,
    onLegalChange: handleLegalChange,
    onSubmit: onSubmit,
    privacyPolicyLink: privacyPolicyLink,
    submitText: submitText,
    termsAndConditionsLink: termsAndConditionsLink,
    shortPolicy: shortPolicy,
    onSocialClick: onSocialClick,
    signInLinkProps: getSignInLinkProps()
  }))), successMessage && React.createElement("div", {
    className: styles.captureForm
  }, React.createElement("h3", {
    className: styles.header
  }, gettext("account.login.with_magic_link.check_inbox.title")), React.createElement(SVGIcon, {
    className: styles.mailPlane,
    name: "mail-plane"
  }), React.createElement("p", null, gettext("account.login.check_confirmation_email_inbox.text")))));
}
export default withReduxProvider(connect(mapStateToProps, mapDispatchToProps)(EmailCaptureOverlay));
EmailCaptureOverlay.propTypes = {
  captureType: PropTypes.oneOf(["signup_lead_save", "signup_pdp_save", "signup_feed_save", "signup_du", "signup_search", "stock_alert", "stock_alert_lead_return", "signup_oos_save", "ta_collection"]),
  closeCustomerCaptureOverlay: PropTypes.func,
  cookiePolicyLink: PropTypes.string,
  designerId: PropTypes.number,
  next: PropTypes.string,
  overlayOpen: PropTypes.bool,
  privacyPolicyLink: PropTypes.string,
  productId: PropTypes.string,
  searchGender: PropTypes.string,
  searchTerm: PropTypes.string,
  termsAndConditionsLink: PropTypes.string,
  shortPolicy: PropTypes.bool,
  signInLink: PropTypes.string
};